import {Module} from 'vuex';
import {
    fetchEnterpriseFilter,
    fetchEnterpriseRank,
    fetchEnterpriseFilterView,
    fetchEnterpriseTotal,
    fetchPrivewTotal,
    fetchViewRank,
    fetchViewRankRegion,
    fetchShareRankC, fetchViewRankCommentOther,
    fetchViewRankComment
} from "@/js/user-share-data.service";

/**
 * 用户分享数据模块
 * @type {Module}
 */
export const viewIndex = {
    namespaced: true,
    state: {
        // 统计总数据
        shareDataTotal: [
            {
                title: '今日转发',
                key: 'today',
                value: 0
            }, {
                title: '本月转发',
                key: 'month',
                value: 0
            }, {
                title: '累计转发',
                key: 'total',
                value: 0
            }
        ],
        // 阅读统计数据
        shareDataTotalView: [
            {
                title: '今日阅读',
                key: 'today',
                value: 0
            }, {
                title: '本月阅读',
                key: 'month',
                value: 0
            }, {
                title: '累计阅读',
                key: 'total',
                value: 0
            }
        ],
        // 激活的排行
        activeRankKey: 'region',
        // 排行筛选参数
        rankSelectParams: {
            // date
            region_Id: undefined, // number | string, // 大区id 多个用英文逗号分隔
            office_Id: undefined, // number | string, // 办事处id 多个用英文逗号分隔
            attr: undefined, // string, // 人员属性 ao ：ao人员；dl ：代理商人员 ，多个用英文逗号分隔
            // time
            start_date: undefined, // string, // 开始时间
            end_date: undefined, //string, // 结束时间
            // order
            order: JSON.stringify({total_desc: 1, total_asc: 0}), //  {        total_desc: 1 | 0, // 总数升序 0：否；1：是        total_asc: 1 | 0, // 总数降序 0：否；1：是
        },
        // 页面表格排行数据
        rankResultList: [],
        // 列表总数
        rankResultTotal: 0,
        // 列表分页
        rankResultPage: 0,
        rankDefaultPage: 0,
        rankResultPageSize: 20,
        // 人员筛选属性
        datePersonType: [
            {
                title: 'AO人员',
                key: 'ao',
                select: false,
            }, {
                title: '代理商人员',
                key: 'dl',
                select: false,
            }
        ],
        dateType:'pool_discuss',
        dateType2:[],
        dateReadNum:[
            // pool_discuss 评价池 url口碑链接阅读量 product 产品详情阅读量 case 更多案例阅读量 更多评价阅读量 more_discuss
            {
                title: '评价池阅读量',
                key: 'pool_discuss',
                select: false,
            },{
                title: '口碑链接阅读量',
                key: 'url',
                select: false,
            },{
                title: '产品详情阅读量',
                key: 'product',
                select: false,
            },{
                title: '更多案例阅读量',
                key: 'case',
                select: false,
            },{
                title: '更多评价阅读量',
                key: 'more_discuss',
                select: false,
            },{
                title: '口碑案例阅读量',
                key: 'koubei',
                select: false,
            }
        ],
        // 用户id
        tp5XcxUserid: undefined,
        /**
         * 数据筛选大区数据
         * @type { Array<{id:number; name:string; select?:boolean}> }
         */
        rankSelectAreaResult: [],
        rankCommentList:[],
        rankCommentView:[],
        /**
         * 数据筛选办事处数据
         * @type { Array<{id:number; name:string; select?:boolean}> }
         */
        rankSelectJobResult: [],
        // 办事处列表搜索词
        jobResultSearchWord: '',
        // 城市选择数据
        objProvince:{
            province:'',
            province_id:'',
            city_id:'',
            city:'',
        },
    },
    mutations: {
        /**
         * 设置用户ID
         * @param state
         * @param typeAction
         * @constructor
         */
        SET_USER_ID(state, typeAction) {
            state.tp5XcxUserid = typeAction.id;
        },
        /**
         * 改变选中所有办事处状态
         * @param state
         * @param {{all:boolean,office:{id:number;select?:boolean;}}} typeAction
         * @constructor
         */
        CHANGE_SELECT_OFFICE(state, typeAction) {
            const {all, office} = typeAction;
            // 根据是否有单项判断全选
            if (!office) {
                state.rankSelectJobResult = state.rankSelectJobResult.map(i => {
                    i.select = !all;
                    return i;
                });
            } else {
                const {id, select} = office;
                state.rankSelectJobResult = state.rankSelectJobResult.map(i => {
                    if (i.id === id) i.select = !select;
                    return i;
                });
            }
        },
        /**
         * 改变搜索词
         * @param state
         * @param {{input:string}} typeAction
         * @constructor
         */
        CHANGE_SEARCH_WORD(state, typeAction) {
            state.jobResultSearchWord = typeAction.input;
        },
        /**
         * 设置数据筛选配置数据
         * @param state
         * @param typeAction
         * @constructor
         */
        SET_SELECT_DATE_OPTION(state, typeAction) {
            const {result} = typeAction;
            console.log(result,'阅读大区2')
            state.rankSelectAreaResult = result;
            // state.rankSelectJobResult = office;
        },
        /**
         * 设置统计总数据
         * @param state
         * @param typeAction
         */
        CHANGE_SHARE_TOTAL(state, typeAction) {
            /**
             * @type {{ month: number; today: number;total: number;}}
             */
            const {result} = typeAction;

            state.shareDataTotal = state.shareDataTotal.map((i) => {
                i.value = result[i.key];
                return i;
            })
        },
        CHANGE_VIEW_TOTAL(state, typeAction) {
            /**
             * @type {{ month: number; today: number;total: number;}}
             */
            const {result} = typeAction;

            state.shareDataTotalView = state.shareDataTotalView.map((i) => {
                i.value = result[i.key];
                return i;
            })
        },
        /**
         * 切换激活的排行
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_ACTIVE_RANK(state, typeAction) {
            state.activeRankKey = typeAction.key;
        },
        /**
         * 改变表格资源
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_TABLE_RESULT_LIST(state, typeAction) {
            const {lists, total, push, page} = typeAction;
            // 区分是否第一页
            push ? state.rankResultList.push(...lists) : (state.rankResultList = lists);
            state.rankResultTotal = total;
            state.rankResultPage = push ? page : state.rankDefaultPage + 1;
        },
        // 评论阅读
        CHANGE_TABLE_COMMENT_VIEW_RESULT_LIST(state, typeAction) {
            const {lists, total, push, page} = typeAction;
            // 区分是否第一页
            push ? state.rankCommentView.push(...lists) : (state.rankCommentView = lists);
            state.rankResultTotal = total;
            state.rankResultPage = push ? page : state.rankDefaultPage + 1;
        },
        // 评论转发
        CHANGE_TABLE_RESULT_LIST_COMMENT(state, typeAction) {
            const {lists, total, push, page} = typeAction;
            // 区分是否第一页
            push ? state.rankCommentList.push(...lists) : (state.rankCommentList = lists);
            state.rankResultTotal = total;
            state.rankResultPage = push ? page : state.rankDefaultPage + 1;
        },
        /**
         * 改变排行表单时间内容
         * @param state
         * @param {{ time?:{start:string; end:string} }} typeAction
         * @constructor
         */
        CHANGE_RANK_SELECT_TIME(state, typeAction) {
            const {time = {}} = typeAction;
            const {start, end} = time;
            state.rankSelectParams.start_date = start;
            state.rankSelectParams.end_date = end;
        },
        /**
         * 改变排行表单排序内容
         * @param state
         * @param {{order?:string}} typeAction
         * @constructor
         */
        CHANGE_RANK_SELECT_ORDER(state, typeAction) {
            const {order} = typeAction;
            state.rankSelectParams.order = order;
        },
        /**
         * 改变排行表单数据筛选内容
         * @param state
         * @param {{cancel?:boolean}} typeAction
         * @constructor
         */
        CHANGE_RANK_SELECT_DATE(state, typeAction) {
            const {cancel} = typeAction;
            console.log( state.rankSelectAreaResult,' state.rankSelectAreaResult')
            // 大区IDS
            state.rankSelectParams.region_Id = cancel ? undefined : state.rankSelectAreaResult.filter(i => i.select)
                .reduce((pre, item) => `${item.region_value},${pre}`, '');
            // // 办事处IDS
            // state.rankSelectParams.office_Id = cancel ? undefined : state.rankSelectJobResult.filter(i => i.select)
            //     .reduce((pre, item) => `${item.id},${pre}`, '');
            // // 代理人属性
            // state.rankSelectParams.attr = cancel ? undefined : state.datePersonType.find(i => i.select)?.key
        },
        /**
         * 改变大区的选择
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_AREA_SELECT(state, typeAction) {
            const {area: {region_value, select} = {}} = typeAction;
            state.rankSelectAreaResult = state.rankSelectAreaResult.map(i => {
                if (region_value) {
                    i.region_value === region_value && (i.select = !select);
                } else {
                    i.select = false;
                }
                return i;
            });

        },
        /**
         * 改变人员的选择
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_PERSON_SELECT(state, typeAction) {
            const {person: {key, select} = {}} = typeAction;
            state.datePersonType = state.datePersonType.map(i => {
                i.select = false;
                i.key === key && (i.select = !select);
                return i;
            });
        },
        CHANGE_READ_NUM (state,typeAction) {
            const {person: {key, select} = {}} = typeAction;
            state.dateReadNum = state.dateReadNum.map(i => {
                i.select = false;
                i.key === key && (i.select = !select);
                return i;
            });
            state.dateType = state.dateReadNum.find( item => item.select).key
        },
        CHANGE_READ_NUM2 (state,typeAction) {
            console.log(typeAction,'typeAction')
            const { key } = typeAction.person
            state.dateReadNum = state.dateReadNum.map(i => {
                if ( i.key == key ) i.select = !i.select
                return i
            });
            state.dateType2 = state.dateReadNum.filter( item => item.select).map( item => item.key)
            console.log(state.dateType2,'state.dateType2')
        },
        CHANGE_PROVINCE(state,typeAction){
            state.objProvince = typeAction.obj;
        },
    },
    actions: {
        /**
         * 获取分享总统计
         * @return {Promise<void>}
         */
        async fetchEnterpriseTotalAction({commit, state}) {
            const {result} = await fetchEnterpriseTotal(state.tp5XcxUserid);
            commit({type: 'CHANGE_SHARE_TOTAL', result});
        },
        // 阅读数据
        async fetchViewTotalAction({commit, state}) {
            const {result} = await fetchPrivewTotal(state.tp5XcxUserid);
            commit({type: 'CHANGE_VIEW_TOTAL', result});
        },
        // 获取排行数据
        async fetchListShare({state, commit}, typePayload) {
            this.dispatch('userShareData/fetchShareTotalAction')
            commit('loadSwitch', true, {root: true});
            // 默认是拉取第一页
            const {push = false} = typePayload;
            console.log(state.activeRankKey,'阅读排行类型')
            console.log(state.rankSelectParams,'rankSelectParams')
            const requestDate = {
                type: state.activeRankKey,
                page: push ? state.rankResultPage : state.rankDefaultPage,
                row: state.rankResultPageSize,
                ...state.rankSelectParams,
                user_id: state.tp5XcxUserid,
                province_id: state.objProvince.province_id || '',
                city_id: state.objProvince.city_id || '',
            };
            const {result: {lists, total}} = await fetchShareRankC(requestDate);
            // 填充数据
            commit({type: 'CHANGE_TABLE_RESULT_LIST_COMMENT', lists, page: requestDate.page + 1, total, push});
            commit('loadSwitch', false, {root: true})
        },

        /**
         * 获取评论阅读排行数据
         * @return {Promise<void>}
         */
        async fetchViewRankC({state, commit}, typePayload) {
            this.dispatch({type:'userShareData/fetchViewTotalActionC',source:this.state.userShareDataView.dateType2.join(',')})


            commit('loadSwitch', true, {root: true});
            // 默认是拉取第一页
            const {push = false} = typePayload;
            // 请求数据
            if(state.activeRankKey=='region'){
                console.log(state.rankSelectParams,'阅读排行类型')
                const requestDate = {
                    type: state.dateType2.join(','),
                    page: push ? state.rankResultPage : state.rankDefaultPage,
                    row: state.rankResultPageSize,
                    ...state.rankSelectParams,
                    user_id: state.tp5XcxUserid,
                    province_id: state.objProvince.province_id || '',
                    city_id: state.objProvince.city_id || '',
                };
                const {result: {lists, total}} = await fetchViewRankComment(requestDate);
                // 填充数据
                commit({type: 'CHANGE_TABLE_COMMENT_VIEW_RESULT_LIST', lists, page: requestDate.page + 1, total, push});
                commit('loadSwitch', false, {root: true})
            }else{
                console.log(state.activeRankKey,'阅读排行类型')
                const requestDate = {
                    type: state.activeRankKey,
                    search:state.dateType2.join(','),
                    page: push ? state.rankResultPage : state.rankDefaultPage,
                    row: state.rankResultPageSize,
                    ...state.rankSelectParams,
                    user_id: state.tp5XcxUserid,
                    province_id: state.objProvince.province_id || '',
                    city_id: state.objProvince.city_id || '',
                };
                const {result: {lists, total}} = await fetchViewRankCommentOther(requestDate);
                // 填充数据
                commit({type: 'CHANGE_TABLE_COMMENT_VIEW_RESULT_LIST', lists, page: requestDate.page + 1, total, push});
                commit('loadSwitch', false, {root: true})
            }
        },




        /**
         * 获取排行数据
         * @return {Promise<void>}
         */
        async fetchEnterpriseRankAction({state, commit}, typePayload) {
            commit('loadSwitch', true, {root: true});

            // 默认是拉取第一页
            const {push = false} = typePayload;
            // 请求数据
            if(state.activeRankKey!='region'){
                console.log(state.activeRankKey,'阅读排行类型')
                const requestDate = {
                    type: state.activeRankKey,
                    page: push ? state.rankResultPage : state.rankDefaultPage,
                    row: state.rankResultPageSize,
                    ...state.rankSelectParams,
                    tp5xcxuserid: state.tp5XcxUserid,
                    province_id: state.objProvince.province_id || '',
                    city_id: state.objProvince.city_id || '',
                };
                const {result: {lists, total}} = await fetchViewRank(requestDate);
                // 填充数据
                commit({type: 'CHANGE_TABLE_RESULT_LIST', lists, page: requestDate.page + 1, total, push});
                commit('loadSwitch', false, {root: true})
            }else{
                console.log(state.activeRankKey,'阅读排行类型')
                const requestDate = {
                    type: state.activeRankKey,
                    page: push ? state.rankResultPage : state.rankDefaultPage,
                    row: state.rankResultPageSize,
                    ...state.rankSelectParams,
                    tp5xcxuserid: state.tp5XcxUserid,
                    province_id: state.objProvince.province_id || '',
                    city_id: state.objProvince.city_id || '',
                };
                const {result: {lists, total}} = await fetchViewRankRegion(requestDate);
                // 填充数据
                commit({type: 'CHANGE_TABLE_RESULT_LIST', lists, page: requestDate.page + 1, total, push});
                commit('loadSwitch', false, {root: true})
            }

        },
        /**
         * 请求排行筛选数据筛选配置数据
         * @param commit
         * @param state
         * @return {Promise<void>}
         */
        async fetchEnterpriseFilterAction({commit, state}) {
            const {result} = await fetchEnterpriseFilterView(state.tp5XcxUserid);
            commit({type: 'SET_SELECT_DATE_OPTION', result})
        }
    },
    getters: {
        /**
         * 选中的办事处
         * @return {function(*): T[]}
         */
        selectJobResult: (state) => {
            return state.rankSelectJobResult.filter(i => i.select);
        },
        /**
         * 是否全选
         * @return {function(*)}
         */
        selectJobAll: (state) => {
            return state.rankSelectJobResult.length && state.rankSelectJobResult.every(i => i.select);
        },
        /**
         * 办事处页面列表数据
         * @param state
         * @return {function(*): {id: number, name: string, select?: boolean}[]}
         */
        rankSelectJobResultList: (state) => {
            return state.rankSelectJobResult.filter(item => {
                return state.jobResultSearchWord ? item.name.includes(state.jobResultSearchWord) : true
            })
        },
        /**
         * 是否加载完毕
         * @param state
         */
        loadMoreEnd: (state) => {
            return (state.rankResultPageSize * state.rankResultPage) >= state.rankResultTotal
        }
    },
}

